<template>
  <footer id="footer" class="footer">
    <div class="wrap-lg">
      <div class="footer_center">
        <span>
          合作单位：{{commonUtils.getDictName('web_display_config','sponsor')}}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span>
        <a href="http://platform.darihua.com" style="color:#ffffff;margin-left: 20px;text-decoration: none" target="_blank">大日化工作台</a>
           </span>
        <el-divider direction="vertical"></el-divider>
        <span>
        <a href="http://org.darihua.com" style="color:#ffffff;margin-left: 20px;text-decoration: none;" target="_blank">检测机构工作台</a>
        </span>
        <el-divider direction="vertical"></el-divider>
        <span>
          网址：{{commonUtils.getDictName('web_display_config','website')}}
         <span><a :href="commonUtils.getDictName('web_display_config','beian_target')" style="color:#ffffff;margin-left: 20px;" target="view_window">{{commonUtils.getDictName('web_display_config','beian')}}</a></span>
        </span>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'bottomFooter'
}
</script>

<style lang="scss" scoped>
  .footer {
    background: #32A08C;
    color: #ffffff;
    font-size: 14px;
    padding: 10px 0 10px 0;
    min-width: 1226px;
    .footer_center{
      display: flex;
      justify-content: space-between;
    }
  }
</style>
